import { getToken } from '@/utils/request';
import axios from 'axios';

export default {
  // computed: {
  //   ...mapState('log', ['needUpdateSource'])
  // },
  // data () {
  //   return {
  //     canSetSource: true
  //   }
  // },
  methods: {
    // ...mapMutations('log', [types.SET_NEED_UPDATE_SOURCE]),
    initAxiosConfig() {
      try {
        axios.defaults.headers['paas-token'] = getToken();
        axios.defaults.headers['req-agent'] = 'apm';
      // eslint-disable-next-line no-empty
      } catch (e) {}
    },
  },
  created() {
    this.initAxiosConfig();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(vm)
      // vm.canSetSource && vm.setNeedUpdateSource(true)
      // vm.canSetSource = false
      vm.initAxiosConfig();
      // 判断当前是否需要切
      // vm.$nextTick(() => {
      //   // 判断当前是否需要切
      //   setTimeout(() => {
      //     vm.setNeedUpdateSource(false)
      //     vm.canSetSource = true
      //   }, 100)
      // })
    });
  },
};
